/**
 * Central Configuration for Health Store Pakistan
 * All phone numbers, WhatsApp, shipping rates, and store metadata are managed here.
 */

export const STORE_CONFIG = {
  name: 'HEALTH STORE',
  legalName: 'Health Store Pakistan (Pvt.) Ltd.',
  tagline: 'Your Trusted Health & Nutrition Store',
  
  // Contact details
  phone: '03229768391',
  phoneDisplay: '0322-9768391',
  whatsappNumber: '923229768391',
  whatsappDisplay: '0322-9768391',
  whatsappDefaultMessage: 'Hello Health Store, I would like to inquire about MalRich products.',
  email: 'abdulsamikhan121212@gmail.com',
  salesEmail: 'abdulsamikhan121212@gmail.com',
  adminNotificationEmail: 'abdulsamikhan121212@gmail.com',
  
  // Physical & operational details
  address: 'Commercial Plaza, Karachi, Pakistan',
  businessHours: '24/7 Customer Support',
  
  // Shipping and Payment configuration
  freeShippingThreshold: 2000,
  standardShippingFee: 200,
  currency: 'PKR',
  currencySymbol: 'Rs.',
  
  // Marketing Pixels
  defaultTikTokPixelId: 'DA86HQBC77UES9745BGG',
  defaultMetaPixelId: '1041026968930278',

  // Announcement text
  announcementText: 'Increase your Height with MAXBIQ Powder',
  promoTrustBar: '🚚 CASH ON DELIVERY   |   ⚡ FAST SHIPPING ALL PAKISTAN   |   📞 24/7 WHATSAPP: 0322-9768391',
  
  // Social links & WhatsApp helper
  getWhatsAppUrl(customMessage?: string) {
    const message = encodeURIComponent(customMessage || STORE_CONFIG.whatsappDefaultMessage);
    return `https://wa.me/${STORE_CONFIG.whatsappNumber}?text=${message}`;
  },
  
  // Format PKR price helper
  formatPrice(amount: number): string {
    const formatted = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `Rs. ${formatted} PKR`;
  }
};
